import { useSyncExternalStore } from 'react'
import type { Doc } from '@/integrations/zustand-store/types/Doc'

type PresenceRecordContext = {
  documentCollectionId: string | null
  recordId: string | null
}

const defaultContext: PresenceRecordContext = {
  documentCollectionId: null,
  recordId: null,
}

let currentContext = defaultContext
const listeners = new Set<() => void>()

function emitChange() {
  for (const listener of listeners) {
    listener()
  }
}

function setContext(nextContext: PresenceRecordContext) {
  if (
    currentContext.documentCollectionId === nextContext.documentCollectionId &&
    currentContext.recordId === nextContext.recordId
  ) {
    return
  }

  currentContext = nextContext
  emitChange()
}

function clearContextForDocument(document: Doc | null) {
  if (!document) {
    return
  }

  if (
    currentContext.documentCollectionId === document.documentCollectionId &&
    currentContext.recordId === document._id
  ) {
    setContext(defaultContext)
  }
}

export function usePresenceRecordContext() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)

      return () => {
        listeners.delete(listener)
      }
    },
    () => currentContext,
    () => currentContext,
  )
}

export function setPresenceRecordContext(document: Doc) {
  setContext({
    documentCollectionId: document.documentCollectionId,
    recordId: document._id,
  })
}

export function clearPresenceRecordContext(document: Doc | null) {
  clearContextForDocument(document)
}
